import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { WebHooksState } from '../WebHooksState';

export const makeCloseSavedSecretDialog =
  (updateState: DraftStateUpdater<WebHooksState>) => (): void => {
    updateState((draft) => {
      draft.savedSecret = null;
    });
  };
